import React from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import {
  CognitoAiStats,
  CognitoAiDataGrid,
  CognitoAiUploadTile,
} from "../components/cognito-ai";

const CognitoAiFragment = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid size={{ xs: 2, sm: 4, md: 12, lg: 12 }}>
          <Card variant="outlined">
            <CardContent>
              <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }} alignItems="stretch">
                <Grid size={{ xs: 12, md: 10, lg: 10 }}>
                  <CognitoAiStats />
                </Grid>
                <Grid size={{ xs: 12, md: 2, lg: 2 }}>
                  <CognitoAiUploadTile />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <Card variant="outlined">
            <CardHeader title="Cognito AI Uploads"></CardHeader>
            <CardContent>
              <CognitoAiDataGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default CognitoAiFragment;
